import { createSelector } from 'reselect'
import links from 'common/helpers/links'


const isMainPageSelector = createSelector(
  (state: ReduxState) => state.routing.location.pathname,
  (pathname: string) => (
    pathname === links.subscription.mainMen
    || pathname === links.subscription.mainWomen
  )
)


export default isMainPageSelector
